import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Encrypt from './pages/Encrypt';
import Decrypt from './pages/Decrypt';
import About from './pages/About';
import Learn from './pages/Learn';
import SOS from './pages/SOS';
import SignLanguage from './pages/SignLanguage';
import MorseCode from './pages/MorseCode';
import SignalHub from './pages/SignalHub';
import Quiz from './pages/Quiz';
import Chatbot from './components/Chatbot';
import WelcomeModal from './components/WelcomeModal';
import { ThemeProvider, ThemeContext } from './theme';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import 'aos/dist/aos.css';
import AOS from 'aos';

function AppContent() {
  const [user, setUser] = useState(null);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    AOS.init({ duration: 700, once: true });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [theme]);

  useEffect(() => {
    const savedUser = localStorage.getItem('signcrypt_user');
    if (!savedUser) {
      setShowWelcomeModal(true);
    } else {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleUserRegistration = (userData) => {
    setUser(userData);
    localStorage.setItem('signcrypt_user', JSON.stringify(userData));
    setShowWelcomeModal(false);
  };

  // SOS Button Component (inside Router context)
  const SOSButton = () => {
    const navigate = useNavigate();
    return (
      <div className="sos-button-container">
        <button 
          className="sos-btn"
          onClick={() => navigate('/sos')}
          title="Emergency SOS"
        >
          🚨
        </button>
      </div>
    );
  };

  return (
    <>
      {/* SOS Button - Top Right */}
      <SOSButton />

      {/* Main Content */}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/encrypt" element={<Encrypt />} />
          <Route path="/decrypt" element={<Decrypt />} />
          <Route path="/about" element={<About />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/sos" element={<SOS />} />
          <Route path="/sign-language" element={<SignLanguage />} />
          <Route path="/morse-code" element={<MorseCode />} />
          <Route path="/signal-hub" element={<SignalHub />} />
          <Route path="/quiz" element={<Quiz />} />
        </Routes>
      </main>

      {/* Navigation */}
      <Navbar />

      {/* Chatbot */}
      <div className="chatbot-container">
        <button
          className="chatbot-btn"
          onClick={() => setShowChatbot(true)}
          title="Chat with Assistant"
          aria-label="Open chat"
        >
          {/* Inline SVG chat bubble for crisper rendering */}
          <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v14l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
          </svg>
        </button>
      </div>

      {/* Welcome Modal */}
      {showWelcomeModal && (
        <WelcomeModal onRegister={handleUserRegistration} />
      )}

      {/* Chatbot Modal */}
      {showChatbot && (
        <Chatbot onClose={() => setShowChatbot(false)} />
      )}
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App; 